import SavedRepliesList from './SavedRepliesList';

export default SavedRepliesList;
